/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBlock8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 .667a3.333 3.333 0 1 0 0 6.666A3.333 3.333 0 0 0 4 .667ZM2.115 2.114a2.667 2.667 0 0 1 3.52-.22L1.895 5.634a2.667 2.667 0 0 1 .22-3.52Zm.25 3.993a2.667 2.667 0 0 0 3.742-3.742L2.365 6.107Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM3.172 3.172a4 4 0 0 1 5.281-.332L2.84 8.453a4 4 0 0 1 .332-5.281Zm.376 5.988A4 4 0 0 0 9.16 3.548L3.548 9.16Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334ZM4.228 4.23a5.333 5.333 0 0 1 7.042-.442l-7.483 7.484a5.334 5.334 0 0 1 .441-7.042Zm.502 7.985a5.334 5.334 0 0 0 7.483-7.484L4.73 12.214Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM6.343 6.343a8 8 0 0 1 10.563-.662L5.681 16.906a8 8 0 0 1 .662-10.563Zm.752 11.977A8 8 0 0 0 18.32 7.095L7.095 18.32Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBlock = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconBlock8 {...iconProps} />;
        case '12':
            return <IconBlock12 {...iconProps} />;
        case '16':
            return <IconBlock16 {...iconProps} />;
        case '24':
            return <IconBlock24 {...iconProps} />;
        default:
            return <IconBlock24 {...iconProps} />;
    }
});
